import type { ReactNode } from 'react';

/**
 * Settings form section — white card with a sentence-case header row.
 * Reusable across all Settings pages (PROD-755..766).
 */
export function SectionCard({ header, children }: { header: string; children: ReactNode }) {
  return (
    <section className="rounded-lg border border-black/5 bg-white shadow-[0_1px_2px_rgba(0,0,0,0.04)]">
      <header className="px-6 py-3 border-b border-black/5">
        <h2 className="text-xs font-medium text-[var(--color-text-muted)]">
          {header}
        </h2>
      </header>
      <div className="px-6 py-6 flex flex-col gap-6">{children}</div>
    </section>
  );
}

export function FieldLabel({ children }: { children: ReactNode }) {
  return (
    <label className="block text-xs font-medium text-[var(--color-text-muted)] mb-2">
      {children}
    </label>
  );
}
